module.exports = __webpack_public_path__ + "static/media/github.9f92baaa.jpg";